import React from "react";
import DepartmentCard from "./DepartmentCard";
import { extractDepartmentData } from "variables/constants";

const DepartmentGridCard = ({ messages, selectedDepartment, onSelectDepartment, departmentOptions }) => {

    const realDepartments = departmentOptions?.filter(dept => dept.value !== "all") || [];
    const departments = extractDepartmentData(messages, realDepartments);

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3">
            {departments.map((dept, index) => (
                <DepartmentCard
                    key={index}
                    recordData={dept}
                    selected={selectedDepartment === dept.department} 
                    onClick={() =>
                        onSelectDepartment(
                            selectedDepartment === dept.department ? "All" : dept.department
                        )
                    }
                />
            ))}
        </div>
    )
};
export default DepartmentGridCard;